import { render, staticRenderFns } from "./popup-documents.vue?vue&type=template&id=9396fe54"
import script from "./popup-documents.vue?vue&type=script&lang=js"
export * from "./popup-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports